module.exports = __webpack_public_path__ + "img/creditos-cc.8b385472.svg";